/**
 * Game constants for Word Drift
 * Centralized configuration to avoid magic numbers throughout the codebase
 */

export const PATHFINDING_CONSTANTS = {
  MIN_COSINE_BRIDGE_THRESHOLD: 0.75,
  GOAL_WORD_INCLUSION_THRESHOLD: 0.75,
  MIN_WORD_LENGTH: 2,
} as const;

export const WORD_SELECTION_CONSTANTS = {
  MAX_CLICKABLE_WORDS: 6,
  NUM_GOAL_SIMILAR_WORDS: 3,
  NUM_RED_HERRING_WORDS: 1,
} as const;

export const FEEDBACK_TYPE = {
  WARMER: 'warmer',
  SAME: 'same',
  COLDER: 'colder',
} as const;

export type FeedbackType = typeof FEEDBACK_TYPE[keyof typeof FEEDBACK_TYPE];
